import React from "react";

// plugin imports

// style imports
import "./spacers.scss";

// component imports

// svg imports

// component
export default function Separator({
	vertical = false,
	thick = false,
	red = false,
}) {
	return (
		<div
			className={`separator
				${vertical ? "vertical" : ""}
				${thick ? "thick" : ""}
				${red ? "red" : ""}`}
		/>
	);
}
